import React from "react";
import { getIconUrl } from "../../../services/asset";
import styles from "./FilterSwitch.scss";

const FilterSwitch = ({ isMobile, onToggleFilter }) => {
  if (!isMobile) {
    return null;
  }

  return (
    <span
      tabIndex={0}
      role="button"
      onClick={onToggleFilter}
      className={styles.switchFilterButtonMobile}
    >
      <img
        alt={"Filtriraj"}
        src={getIconUrl("filter.svg")}
      />
      <span>{"Filtriraj"}</span>
    </span>
  );
};

FilterSwitch.defaultProps = {
  isMobile: false
};

export default FilterSwitch;



// WEBPACK FOOTER //
// ./src/containers/SearchPage/FilterSwitch/index.tsx